import { isSupabaseConfigured } from '../../../lib/services';
import { supabase } from '../../../lib/supabase';
import type { Shift, ShiftFormData } from '../types';

export const shiftService = {
  async getAll(): Promise<Shift[]> {
    if (!isSupabaseConfigured()) {
      const mockShifts: Shift[] = [
        {
          id: 'shift-1',
          staff_id: 'staff-1',
          date: '2024-01-15',
          start_time: '08:00',
          end_time: '16:00',
          shift_type: 'morning',
          status: 'scheduled',
          created_at: '2024-01-01T00:00:00Z',
          updated_at: '2024-01-01T00:00:00Z'
        }
      ];
      return mockShifts;
    }
    
    const { data, error } = await supabase
      .from('shifts')
      .select('*')
      .order('date', { ascending: false });
    
    if (error) throw error;
    return data as Shift[];
  },

  async getByDateRange(startDate: string, endDate: string): Promise<Shift[]> {
    if (!isSupabaseConfigured()) {
      const mockShifts: Shift[] = [
        {
          id: 'shift-1',
          staff_id: 'staff-1',
          date: '2025-09-11',
          start_time: '08:00',
          end_time: '16:00',
          shift_type: 'morning',
          status: 'scheduled',
          created_at: '2025-09-11T00:00:00Z',
          updated_at: '2025-09-11T00:00:00Z'
        }
      ];
      return mockShifts.filter(shift => 
        shift.date >= startDate && shift.date <= endDate
      );
    }
    
    const { data, error } = await supabase
      .from('shifts')
      .select('*')
      .gte('date', startDate)
      .lte('date', endDate)
      .order('date');
    
    if (error) throw error;
    return data as Shift[];
  },

  async create(shift: ShiftFormData): Promise<Shift> {
    if (!isSupabaseConfigured()) {
      const mockShift: Shift = {
        ...shift,
        id: `shift-${Date.now()}`,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      return mockShift;
    }
    
    const { data, error } = await supabase
      .from('shifts')
      .insert([{ ...shift, updated_at: new Date().toISOString() }])
      .select()
      .single();
    
    if (error) throw error;
    return data as Shift;
  },

  async update(id: string, shift: Partial<ShiftFormData>): Promise<Shift | null> {
    if (!isSupabaseConfigured()) {
      const existing = await this.getById(id);
      return {
        ...existing!,
        ...shift,
        updated_at: new Date().toISOString()
      };
    }
    
    const { data, error } = await supabase
      .from('shifts')
      .update({ ...shift, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data as Shift;
  },

  async getById(id: string): Promise<Shift | null> {
    if (!isSupabaseConfigured()) {
      return {
        id,
        staff_id: 'staff-1',
        date: '2024-01-15',
        start_time: '08:00',
        end_time: '16:00',
        shift_type: 'morning',
        status: 'scheduled',
        created_at: '2024-01-01T00:00:00Z',
        updated_at: '2024-01-01T00:00:00Z'
      };
    }
    
    const { data, error } = await supabase
      .from('shifts')
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data as Shift;
  }
};
